export const persianNumbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"]
export const englishNumbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]

const toEnglishDigits = (number: string): string => {

    return number.split("").map(c => englishNumbers[persianNumbers.indexOf(c)] || c).join("")
}

export default toEnglishDigits